<template>
  <div class="min-w-full md:min-w-[15rem] flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <h4
        class="text-sm font-semibold text-surface-500 uppercase tracking-wider"
      >
        Plot Type
      </h4>
      <Select
        v-model="localPlotType"
        :options="plotTypes"
        option-label="name"
        :loading="plotTypesLoading"
        class="w-full"
        @change="$emit('change')"
      />
    </div>

    <Divider />

    <div
      v-if="localPlotType"
      class="flex flex-row gap-2 justify-between items-center"
    >
      <h4 class="font-semibold text-sm m-0 leading-none">Parameters</h4>

      <div class="flex items-center gap-2">
        <InformationTooltip :tooltip="plotTypeInfo?.description" />
        <Button
          type="button"
          icon="pi pi-play"
          :label="isMobile ? 'Run Plot' : ''"
          :loading="plotLoading"
          @click="$emit('run')"
        />
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div
        v-for="(arg_info, arg_name, index) in plotTypeInfo?.args"
        :key="index"
      >
        <div
          v-if="arg_info.type === 'bool' && !arg_info.hidden"
          class="flex items-center justify-between pl-1"
        >
          <label class="text-sm">
            {{ arg_name.replaceAll("_", " ")
            }}{{ arg_info.required ? "*" : "" }}
          </label>
          <ToggleSwitch v-model="localParams[arg_name]" />
        </div>

        <IftaLabel v-else-if="!arg_info.hidden" class="w-full" variant="on">
          <Select
            v-if="arg_info.type === 'Column'"
            v-model="localParams[arg_name]"
            :options="queryStoreResultCols"
            class="w-full"
          />
          <Select
            v-else-if="arg_info.values"
            v-model="localParams[arg_name]"
            :options="arg_info.values"
            class="w-full"
          />
          <InputNumber
            v-else-if="['int', 'float'].includes(arg_info.type)"
            v-model="localParams[arg_name]"
            class="w-full"
            :max-fraction-digits="arg_info.type === 'float' ? 20 : 0"
          />
          <InputText v-else v-model="localParams[arg_name]" class="w-full" />
          <label
            >{{ arg_name.replaceAll("_", " ")
            }}{{ arg_info.required ? "*" : "" }}</label
          >
        </IftaLabel>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import Select from "primevue/select";
import Divider from "primevue/divider";
import Button from "primevue/button";
import IftaLabel from "primevue/iftalabel";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import ToggleSwitch from "primevue/toggleswitch";
import InformationTooltip from "@/components/InformationTooltip.vue";

const props = defineProps({
  plotType: { type: Object, default: null },
  params: { type: Object, default: () => ({}) },
  plotTypes: { type: Array, default: () => [] },
  plotTypesLoading: { type: Boolean, default: false },
  plotTypeInfo: { type: Object, default: () => ({}) },
  plotLoading: { type: Boolean, default: false },
  queryStoreResultCols: { type: Array, default: () => [] },
  isMobile: { type: Boolean, default: false },
});

const emit = defineEmits(["update:plotType", "update:params", "run", "change"]);

const localPlotType = computed({
  get: () => props.plotType,
  set: (val) => emit("update:plotType", val),
});

const localParams = computed({
  get: () => props.params,
  set: (val) => emit("update:params", val),
});
</script>
